import {
    getIsBitSet,
    type ListViewBitFlagsMasks,
} from 'mini-bit-flags/lib/utils/listViewBitFlagsUtil';

// Gets if Sender image feature is enabled for the user
export default function isSenderImageEnabled(): boolean {
    return !getIsBitSet(8);
}
